<template>
  <div class="onboarding_page">
    <h2>Grattis! Nu är du redo att börja använda Memlist!</h2>
    <p>Tryck på knappen för att stänga denna onboarding.</p>

    <div class="wizard_actions mt-4">
      <memlist-button variant="primary" class="ml-8" @click="finish_onboarding">Klar</memlist-button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'onboarding_page12',
  props: ['onboarding_data'],
  emits: ['finished','prev_page','update_data'],
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    finish_onboarding() {
      this.local_onboarding_data.finished = true;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('finished');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
